var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostArrowTotop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.23447L3.77625 16.9084C3.60508 17.0889 3.32025 17.0962 3.14006 16.9247C2.95988 16.7532 2.95258 16.4678 3.12375 16.2872L11.6738 7.26925C11.8512 7.08213 12.1488 7.08213 12.3263 7.26925L20.8762 16.2872C21.0474 16.4678 21.0401 16.7532 20.8599 16.9247C20.6798 17.0962 20.3949 17.0889 20.2237 16.9084L12 8.23447Z",
    fill: "#E66400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostArrowTotop);
export default __webpack_public_path__ + "static/media/cost_arrow_totop.9a40d04853438629802c532d15fbf44b.svg";
export { ForwardRef as ReactComponent };